import { AppForceUpdate } from "../AppForceUpdate";
import InstaLoginInfoDrawer from "../Home/InstaLoginInfoDrawer";
import { WebForceUpdate } from "../WebForceUpdate";
import { CreatorConfig } from "../../types/creator";
import { getPlatform } from "../../utils/config";

type Props = {
  creatorConfig?: CreatorConfig;
  hasConfigError?: boolean;
};

const AppUpdatePrompt = ({ creatorConfig }: Pick<Props, "creatorConfig">) => {
  if (getPlatform() === "web") return null;
  if (creatorConfig?.is_force_update_native) return <AppForceUpdate open />;
  if (creatorConfig?.is_force_update_web) return <WebForceUpdate />;
  return null;
};

/**
 * Route-independent UI that requires a healthy creator config.
 */
const GlobalOverlays = ({ creatorConfig, hasConfigError }: Props) => {
  if (hasConfigError) return null;

  return (
    <>
      <InstaLoginInfoDrawer />
      <AppUpdatePrompt creatorConfig={creatorConfig} />
    </>
  );
};

export default GlobalOverlays;
